import { useQuery } from "@tanstack/react-query"
import { whatsappTemplatesQuery } from "../../../lib/templates/whatsapp/whatsappTemplatesQuery"

export function useWhatsappTemplatesQuery(...args: Parameters<typeof whatsappTemplatesQuery>) {
  return useQuery(whatsappTemplatesQuery(...args))
}
